export default class ReservationResponse {
  status!: boolean;
  error?: string;
  reservation_id!: number;
  enc_res_id!: string;
  customer_id!: number;

  constructor(data?: Dict) {
    if (!data || !data.success) {
      this.status = false;
      this.error = data?.message;
      return;
    }

    this.status = true;
    this.reservation_id = parseInt(data.reservation_id);
    this.enc_res_id = data.enc_res_id;
    this.customer_id = parseInt(data.customer_id);
  }
}
